<script>
  import projetoServico from '~modulos/projeto/servico';
  import detalheRateioServico from '~modulos/detalhe-rateio/servico';
  import 'vue-strap/dist/vue-strap-lang';

  export default {
    props: {
      solicitacao: {
        type: Object,
        required: true
      },
    },
    data() {
      return {
        configuracao: this.$storage.configuracao(),
        projetos: [],
        detalheRateios: [],
        metaEtapas: [],
        projetoRateio: this.camposProjetoRateio(),
        metaEtapa: false,
      }
    },
    methods: {
      camposProjetoRateio() {
        return {
          idProjeto: '',
          valorRateio: '',
          idProjetoMetaEtapa: '',
          idDetalheRateio: '',
          projeto: {
            idProjeto: '',
            nomeProjeto: '',
            utilizarMetaEtapaProjeto: false,
          },
          detalheRateio: {
            id: '',
            nome: '',
          },
          projetoMetaEtapa: {
            metaEtapa: '',
            idProjetoMetaEtapa: '',
            meta: {
              nome: ''
            },
            etapa: {
              nome: ''
            },
          }
        }
      },
      validar() {
        this.$validator
          .validateAll()
          .then(valido => {
            if (!valido) {
              throw new Error("validacao");
            }
            else {
              this.setarMetaEtapa(this.projetoRateio.idProjetoMetaEtapa);
              this.solicitacao.solicitacaoPagamentoRateio.push(this.projetoRateio);
              this.solicitacao.solicitacaoHasSolicitacao.push({
                id: 0,
                idHasIdSolicitacaoHasSolicitacao: 0,
                idSolicitacao : 0,
              });
              this.projetoRateio = this.camposProjetoRateio();
              $('#projeto').val('0');
              $('#detalhe-rateio').val('0');
              this.iniciarSelect2Projeto();
              this.$validator.reset();
            }
          })
          .catch(erro => {
            this.$mensagemErro(erro);
          });
      },
      validarProjeto() {
        return (this.solicitacao.solicitacaoPagamentoRateio.length > 0);
      },
      deletarProjeto(indice) {
        this.solicitacao.solicitacaoPagamentoRateio.splice(indice, 1);
        this.solicitacao.solicitacaoHasSolicitacao.splice(indice, 1);
      },
      listaDeProjetos() {
        return projetoServico
          .lista("SolPagamentoPessoaFisica")
          .then(projetos => {
            this.projetos = projetos;
          });
      },
      listaDeDetalheRateio() {
        detalheRateioServico
          .lista()
          .then(detalheRateios => {
            this.detalheRateios = detalheRateios;
          });
      },
      listaDeMetaEtapas(idProjeto) {
        projetoServico
          .metaEtapas(idProjeto)
          .then(metaEtapas => {
            this.metaEtapas = metaEtapas;
          });
      },
      setarProjeto(idProjeto) {
        this.projetos.map(projeto => {
          if (projeto.idProjeto == idProjeto) {
            this.$set(this.projetoRateio, 'projeto', projeto);
          }
        });
      },
      setarDetalheRateio(idDetalheRateio) {
        this.detalheRateios.map(detalheRateio => {
          if (detalheRateio.id == idDetalheRateio) {
            this.$set(this.projetoRateio, 'detalheRateio', detalheRateio);
          }
        });
      },
      setarMetaEtapa(idMetaEtapa) {
        this.metaEtapas.map(metaEtapa => {
          if (metaEtapa.idProjetoMetaEtapa == idMetaEtapa) {
            this.$set(this.projetoRateio, 'projetoMetaEtapa', metaEtapa);
          }
        });
      },
      iniciarMetaEtapa() {
        const _this = this;

        $('#metaEtapa').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function(e) {
          _this.$set(_this.projetoRateio, 'idProjetoMetaEtapa', this.value);

          _this.setarMetaEtapa(this.value);
        });
      },
      iniciarSelect2Projeto() {
        const _this = this;

        $('#projeto').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function(e) {
          _this.$set(_this.projetoRateio, 'idProjeto', this.value);

          _this.setarProjeto(this.value);

          if (!this.value) return;

          _this.$set(_this.projetoRateio, 'idProjetoMetaEtapa', '');
          
          if (_this.projetoRateio.projeto.utilizarMetaEtapaProjeto) {
            _this.listaDeMetaEtapas(this.value);
            _this.iniciarMetaEtapa();
          }
        });

        $('#detalhe-rateio').select2({
          theme: "bootstrap",
          placeholder: "Selecione...",
          language: "pt-BR"
        })
        .change(function(e) {
          _this.$set(_this.projetoRateio, 'idDetalheRateio', this.value);

          _this.setarDetalheRateio(this.value);
        });
      },
      permitirCriarSolicitacao(data) {
        return !(data && moment(data).add(1, "d").diff(moment()) < 0);
      },
      retornaTamanhoCampoProjeto(projeto) {
        if (this.configuracao.utilizarDetalheRateioSolicitacao && projeto.utilizarMetaEtapaProjeto) {
          return 'col-xs-4';
        }
        else {
          if (!this.configuracao.utilizarDetalheRateioSolicitacao && !projeto.utilizarMetaEtapaProjeto) {
            return 'col-xs-10';
          }
          else {
            return 'col-xs-7';
          }
        }
      },
    },
    computed: {
      validarDetalheRateio() {
        return this.configuracao.utilizarDetalheRateioSolicitacao ? 'required' : '';
      },
      total: function () {
        return this.solicitacao.solicitacaoPagamentoRateio.reduce((somatorio, item) => {
          const valorEstimado = this.$options.filters.formatarNumero(item.valorRateio, true);
          return somatorio + valorEstimado
        }, 0);
      },
    },
    mounted() {
      this.listaDeProjetos();
      this.iniciarSelect2Projeto();

      if (this.configuracao.utilizarDetalheRateioSolicitacao) {
        this.listaDeDetalheRateio();
      }
    },
  }
</script>

<template>
<div>
  <div class="ibox-footer">
    <div class="table-responsive">
      <table class="table table-bordered table-column-code table-column-action">
        <thead v-if="solicitacao.solicitacaoPagamentoRateio.length > 0">
          <tr>
            <th>Projeto</th>
            <th v-if="configuracao.utilizarDetalheRateioSolicitacao">Detalhe rateio</th>
            <th>Meta etapa</th>
            <th>Valor (R$)</th>
            <th></th>
          </tr>
        </thead>
        <tbody v-if="solicitacao.solicitacaoPagamentoRateio.length > 0">
          <tr v-for="(rateio, index) in solicitacao.solicitacaoPagamentoRateio">
            <td>{{ rateio.projeto.nomeProjeto }}</td>
            <td v-if="configuracao.utilizarDetalheRateioSolicitacao">{{ rateio.detalheRateio ? rateio.detalheRateio.nome : '---' }}</td>
            <td>{{ rateio.projetoMetaEtapa ? rateio.projetoMetaEtapa.meta.nome + ' - ' + rateio.projetoMetaEtapa.etapa.nome : '---' }}</td>
            <td>{{ rateio.valorRateio  }}</td>
            <td>
              <div class="form-group no-margins">
                <button type="button"
                        class="btn btn-sm btn-danger btn-delete-item"
                        title="Excluir item"
                        @click="deletarProjeto(index)">
                  <i class="fa fa-trash"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
        <tfoot v-if="solicitacao.solicitacaoPagamentoRateio.length === 0">
          <tr>
            <td class="text-center">Nenhum rateio de projeto encontrado.</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>

    <div class="bs-callout bs-callout-primary" v-if="configuracao.utilizarValorEstimado">
      <h4>Valor total: R$ {{ total | formatarNumero }}</h4>
    </div>

    <div class="row">
      <div :class="retornaTamanhoCampoProjeto(projetoRateio.projeto)">
        <div class="form-group required" :class="{'has-error': errors.has('projeto')}">
          <label class="control-label" for="projeto">Projeto</label>

          <select id="projeto"
                  class="form-control"
                  v-model="projetoRateio.idProjeto"
                  data-vv-name="projeto"
                  v-validate="'required'">
            <option value="0">Selecione o projeto...</option>
            <option :value="projeto.idProjeto"
                    v-for="(projeto, index) in projetos"
                    :disabled="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao) || projeto.acompanhamentoPendente">
              {{ projeto.nomeProjeto }}

              <template v-if="!permitirCriarSolicitacao(projeto.dataLimiteSolicitacao)">
                (Data limite até: {{ projeto.dataLimiteSolicitacao | formatarData }})
              </template>
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('projeto')">{{ errors.first('projeto') }}</p>
        </div>
      </div>

      <div class="col-xs-3" v-if="projetoRateio.projeto.utilizarMetaEtapaProjeto">
        <div class="form-group required" :class="{'has-error': errors.has('metaEtapa')}">
          <label class="control-label" for="metaEtapa">Meta etapa</label>

          <select class="form-control"
                  id="metaEtapa"
                  v-model="projetoRateio.idProjetoMetaEtapa"
                  data-vv-name="metaEtapa"
                  data-vv-as="meta etapa"
                  v-validate="'required'">
            <option value="">Selecione...</option>
            <option :value="metaEtapa.idProjetoMetaEtapa"
                    v-for="(metaEtapa, index) in metaEtapas">
              {{ `${metaEtapa.meta.nome} - ${metaEtapa.etapa.nome}` }}
            </option>
          </select>

          <p class="text-danger" v-show="errors.has('metaEtapa')">{{ errors.first('metaEtapa') }}</p>
        </div>
      </div>

      <div class="col-xs-3" v-if="configuracao.utilizarDetalheRateioSolicitacao">
        <div class="form-group" :class="[validarDetalheRateio, {'has-error': errors.has('detalheRateio')}]">
          <label class="control-label" for="detalhe-rateio">Detalhe rateio</label>

          <select id="detalhe-rateio"
                  class="form-control"
                  v-model="projetoRateio.idDetalheRateio"
                  data-vv-name="detalheRateio"
                  data-vv-as="detalhe rateio"
                  v-validate="validarDetalheRateio">
            <option value="0">Selecione o detalhe rateio...</option>
            <option :value="detalheRateio.id" v-for="detalheRateio in detalheRateios">{{ detalheRateio.nome }}</option>
          </select>

          <p class="text-danger" v-show="errors.has('detalheRateio')">{{ errors.first('detalheRateio') }}</p>
        </div>
      </div>

      <div class="form-group required col-xs-2" :class="{'has-error': errors.has('valor')}">
        <label class="control-label" for="valor2">Valor (R$)</label>

        <input type="text"
               class="form-control text-right"
               id="valor2"
               v-mascara="'moeda'"
               v-model="projetoRateio.valorRateio"
               data-vv-name="valor"
               data-vv-as="valor"
               v-validate="'required|not_zero'">

        <p class="text-danger" v-show="errors.has('valor')">{{ errors.first('valor') }}</p>
      </div>
    </div>

    <div class="row">
      <div class="col-xs-12">
        <div class="form-group">
          <button type="button" class="btn btn-success" @click="validar">
            <i class="fa fa-plus"></i>
            Adicionar projeto
          </button>
        </div>
      </div>
    </div>

  </div>
</template>



// WEBPACK FOOTER //
// FrontEnd/modulos/solicitacao-pagamento-rateio/juridica/componentes/compartilhado/FormDadosProjetos.vue